import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const check = useCallback(() => api.me().then(setUser).catch(() => setUser(false)), []);

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) return;
    check();
  }, [check]);

  const logout = async () => {
    await api.logout().catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, logout, refresh: check }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
